"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createCache", {
    enumerable: true,
    get: function() {
        return createCache;
    }
});
const _hasher = require("@lage-run/hasher");
async function createCache(options) {
    const { cacheOptions, root, cliArgs, logger } = options;
    const hasher = new _hasher.TargetHasher({
        root,
        environmentGlob: cacheOptions?.environmentGlob ?? [],
        cacheKey: cacheOptions?.cacheKey,
        cliArgs,
        logger
    });
    await hasher.initialize();
    return {
        hasher
    };
}
